export default __webpack_public_path__ + "static/media/DSC_0027.a310dfaf.JPG";